export enum TextbookSections {
  TEXTBOOK = 'textbook',
  DIFF_WORDS = 'diff-words',
}

export enum Navigate {
  PREV,
  NEXT,
}
